var React = require('react');

function Typography (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5226 19.52H20.4778L17.0002 10.2463L13.5226 19.52ZM30.4402 0.199951H3.56019C1.71219 0.199951 0.200195 1.71195 0.200195 3.55995V30.4399C0.200195 32.2879 1.71219 33.7999 3.56019 33.7999H30.4402C32.2882 33.7999 33.8002 32.2879 33.8002 30.4399V3.55995C33.8002 1.71195 32.2882 0.199951 30.4402 0.199951ZM23.6362 27.92L21.721 22.8799H12.2458L10.3642 27.92H6.85299L15.4378 6.07994H18.5626L27.1474 27.92H23.6362Z","fill":"#CCB371"}));
}

Typography.defaultProps = {"viewBox":"0 0 34 34","fill":"none"};

module.exports = Typography;

Typography.default = Typography;
